<template>
    <div style="width: 1300px;margin: 0px auto;">
        <div>
           <div>
             <input v-model="search" style="width:200px" class="el-input__inner" type="text">
            <button @click="sa_article_sour()" type="button" class="el-button el-button--primary" style="width: 120px;margin-bottom: 3px;"><!----><!----><span>sour database</span></button>
            <span style="font-size: 18px;">
                <b>{{tit_name}}</b>
            </span>
             <span id="pass_this_word" style="float:right;display:none">
                 <input v-model="password" style="width:200px" class="el-input__inner" type="password">
                 <button @click="listPage2()" type="button" class="el-button el-button--primary" style="width: 120px;margin-bottom: 3px;"><!----><!----><span>get content</span></button>
             </span>
           </div>
        </div>
        
        <div class="el-row">
          <div id="show_or_hide" class="el-col el-col-5">
            <div>
                <ul>
                    <li class="wtq-sty" style="height: auto;border:0px" v-for="item in left_mean">
                        <div  @click="listPage()" style="border-bottom: 1px solid black;height: 27px;">
                            <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_article', query: {id: item.id}}">{{item.name}}</router-link>
                        </div>
                            <ul>
                                <li style="margin-left: 20px;padding:10px 0 10px 0;" class="wtq-sty" v-for="ite in item.ch" @click="listPage()">
                                    <router-link style="width: 100%;display:block;color:black;" :to="{path: 'sa_type', query: {type_id: ite.id,id: item.id}}">{{ite.type_name}}</router-link>
                                </li>
                            </ul>
                    </li>
                </ul>
            </div>
          </div>
          <div class="el-col el-col-1" style="height:77px">
          
          </div>
          <div class="el-col el-col-18" style="border: 1px solid #60605896;margin-bottom: 7px;" >
            <div>
                <div style="border-bottom: 1px solid #a1a19c;font-size:50px;text-align: center;">
                    <b>{{file.title}}</b>
                    <div style="font-size:12px;float:right;margin: 48px 5px 0 0;">
                    {{file.date}}
                    </div>
                </div>
                <div id="show_file" style="margin: 7px;min-height: 777px;"></div>
            </div>
          </div>
        </div>
    </div>

</template>
<script>
    export default {
        data() {
            return {
                left_mean:'',
                file:'',
                tit_name:'',
            }
        },

        mounted: function () {
            this.listPage();
            this.listPage2();
            this.search='';
            this.password='';
        },

        methods: {
            listPage() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let id=this.get_get_val('id');
                let type_id=this.get_get_val('type_id');
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/show_sa_article?id=' + id+'&en=1&name='+ this.search+'&type_id='+ type_id,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this;
                    _this.left_mean=response.data.left_mean;
                    
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            listPage2() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let id=this.get_get_val('id');
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/show_sa_file?id=' + id + '&en=1&password='+this.password,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this;
                    this.password='';
                    _this.file=response.data;
                    _this.tit_name=response.data.tit_name
                    let reg = new RegExp('"', "g"); // g,表示全部替换
                    //document.getElementById('show_file').innerHTML = eval("'" + _this.file.text + "'").replace(reg, "")
                    var cstring=eval("'" + _this.file.text + "'")
                    cstring=cstring.substr(1,cstring.length-1)
                    cstring=cstring.substr(0,cstring.length-2)
                    document.getElementById('show_file').innerHTML = cstring
                    
                    if(_this.file.show_pass==1){
                        document.getElementById('pass_this_word').style.display = 'none';
                    }else{
                        document.getElementById('pass_this_word').style.display = '';
                    }
                    
                    listPage33(id);
                    
                    if(id){
                        document.getElementById('show_or_hide').style.display = 'none';
                    }else{
                    document.getElementById('show_or_hide').style.display = '';
                    }
                    
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            
            sa_article_sour() {
                // 获取参数type_id的值
                let url = location.href  // 查询当前url
                let id=this.get_get_val('id');
                
                location.href = '/history/sa_sour?name='+ this.search
                
                this.$axios({
                    method:'get',
                    url:'/api/pre/json_go/show_sa_article?id=' + id+'&en=1&name='+ this.search,
                }).then((response) =>{ // 这里使用了ES6的语法
                    let _this = this;
                    _this.left_mean=response.data.left_mean;
                    _this.right_div=response.data.right_div;
                    
                }).catch((error) =>
                    console.log(error)       //请求失败返回的数据
                )
            },
            
            // 下载
            downloadMarkOne: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=1'
            },
            downloadMarkTwo: function (row) {
                location.href = '/api/pre/json_go/file_xz?tool_id='+row.tool_id+'&type=2'
            },
            get_get_val:function (get_name){
                // 获取参数type_id的值
                var reg = new RegExp("(^|&)" + get_name + "=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if (r != null){
                    return decodeURI(r[2]);
                }else{
                    return '';
                }
            },
        }
    }
    function listPage22(){
    alert(1)
    }
    
    function listPage33(id){
        ajax({ 
            type:"POST", 
            url:'https://hr.sinowealth.com:8086/pre/json_go/who_look', 
            dataType:"json",
    		data:{id:id}, 
            beforeSend:function(){ 
              //some js code 
            }, 
            success:function(msg){ 
              alert('ok');
            }, 
            error:function(){ 
              console.log("error") ;
              //alert('回写失败请联系管理员');
            } 
          });
    }
    
    
    function ajax(){
	  var ajaxData = { 
	    type:arguments[0].type || "GET", 
	    url:arguments[0].url || "", 
	    async:arguments[0].async || "true", 
	    data:arguments[0].data || null, 
	    dataType:arguments[0].dataType || "text", 
	    contentType:arguments[0].contentType || "application/x-www-form-urlencoded", 
	    beforeSend:arguments[0].beforeSend || function(){}, 
	    success:arguments[0].success || function(){}, 
	    error:arguments[0].error || function(){} 
	  } 
	  ajaxData.beforeSend() ;
	  var xhr = createxmlHttpRequest();  
	  xhr.responseType=ajaxData.dataType; 
	  xhr.open(ajaxData.type,ajaxData.url,ajaxData.async);  
	  xhr.setRequestHeader("Content-Type",ajaxData.contentType);  
	  xhr.send(convertData(ajaxData.data));  
	  xhr.onreadystatechange = function() {  
	    if (xhr.readyState == 4) {  
	      if(xhr.status == 200){ 
	        ajaxData.success(xhr.response) ;
	      }else{ 
	        ajaxData.error() ;
	      }  
	    } 
	  }  
	}
	function createxmlHttpRequest() {  
	  if (window.ActiveXObject) {  
	    return new ActiveXObject("Microsoft.XMLHTTP");  
	  } else if (window.XMLHttpRequest) {  
	    return new XMLHttpRequest();  
	  }  
	} 
	  
	function convertData(data){ 
	  if( typeof data === 'object' ){ 
	    var convertResult = "" ;  
	    for(var c in data){  
	      convertResult+= c + "=" + data[c] + "&";  
	    }  
	    convertResult=convertResult.substring(0,convertResult.length-1) 
	    return convertResult; 
	  }else{ 
	    return data; 
	  } 
	}

 
function Dropdown44_onchange(){
	if(Dropdown44.value=='X'){
      HiddenTextBox50.value='a1176';
    }else{
      HiddenTextBox50.value='s0208';
    }
}
</script>

<style>
    .wtq-sty{
        height: 20px;
        border-bottom: 1px solid #60605896;
        padding: 10px 0 10px 20px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/product/sa_show.vue